module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "formCustom",
    attrs: {
      "inline": true,
      "label-width": "125px",
      "model": _vm.basicInfo,
      "rules": _vm.ruleCustom
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*书籍名称: ",
      "prop": "bookName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "必填项",
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.basicInfo.bookName),
      callback: function($$v) {
        _vm.$set(_vm.basicInfo, "bookName", $$v)
      },
      expression: "basicInfo.bookName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "书籍封面: "
    }
  }, [_c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "flex"
    }
  }, [(_vm.basicInfo.imgUrl != '') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.basicInfo.imgUrl,
      "width": "80px",
      "height": "80px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Upload', {
    attrs: {
      "action": "/aries-api/resource/upload",
      "accept": "image/jpeg, image/gif, image/png",
      "before-upload": _vm.onBeforeUpload,
      "on-success": _vm.onSuccessUpload,
      "data": _vm.uploadData,
      "show-upload-list": true,
      "disabled": _vm.doWhatTemp === 'view'
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.doWhatTemp === 'view'
    }
  }, [_vm._v("\n              上传\n              "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1)], 1), _vm._v(" "), (_vm.basicInfo.imgUrl != '') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "el-icon-delete",
      "disabled": _vm.doWhatTemp === 'view'
    },
    on: {
      "click": _vm.delFrontCover
    }
  }, [_vm._v("删除")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "书籍品牌: "
    }
  }, [_c('BrandChose', {
    attrs: {
      "brandName": _vm.basicInfo.brand,
      "doWhatTemp": _vm.doWhatTemp,
      "tagIds": _vm.tagIds
    },
    on: {
      "brandChose": _vm.brandChoseHandle
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "书籍等级: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.basicInfo.level),
      callback: function($$v) {
        _vm.$set(_vm.basicInfo, "level", $$v)
      },
      expression: "basicInfo.level"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "作者: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.basicInfo.author),
      callback: function($$v) {
        _vm.$set(_vm.basicInfo, "author", $$v)
      },
      expression: "basicInfo.author"
    }
  })], 1), _vm._v(" "), _c('br')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac531c0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/components/addBook/addBookBasicInfo.vue
// module id = 723
// module chunks = 1